import type { CustomTable } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

export enum CustomTableHeaderDirection {
    Left = "left",
    Top = "top",
    TopLeft = "top_left",
}

export interface ResolvedCustomTable {
    codename: string;
    headerDirection: CustomTableHeaderDirection;
    table: string;
    type: ContentTypeCodenames.CustomTable;
}

const customTableResolver = (data: CustomTable): ResolvedCustomTable => {
    const { headerDirection, table } = data.elements;
    const codename = data.system.codename;

    return {
        codename,
        headerDirection: headerDirection.value[0].codename as CustomTableHeaderDirection,
        table: table.value,
        type: ContentTypeCodenames.CustomTable,
    };
};

export default customTableResolver;
